import { render, staticRenderFns } from "./InvoiceDiscountManager.vue?vue&type=template&id=2fd25010&scoped=true"
import script from "./InvoiceDiscountManager.vue?vue&type=script&lang=js"
export * from "./InvoiceDiscountManager.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDiscountManager.vue?vue&type=style&index=0&id=2fd25010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd25010",
  null
  
)

export default component.exports